// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1YX0wW41aSXqGbJOUPyGpd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/menu.scss
// module id = 194
// module chunks = 0